/**
 * AUTO-GENERATED by `npm run media` — do not edit by hand.
 *
 * Maps a filename to its webpack-bundled URL. Every entry is a real file in
 * this folder, so the build verifies each one: a missing file fails the BUILD
 * rather than shipping a broken <img>. Anything absent from this map falls
 * back to the live WordPress URL (see src/data/media.js), which means a
 * partial download degrades gracefully instead of breaking the site.
 *
 * 53 files bundled.
 */

import a0 from './2150878299.jpg';
import a1 from './Bugolobi-location-arrows-04.svg';
import a2 from './Golden-Hour-0000.webp';
import a3 from './Golden-hour-Table-talker-02.webp';
import a4 from './Grain-background.webp';
import a5 from './Kyanja-location-arrows-05.svg';
import a6 from './Lavender-Lemonades-min-scaled.jpg';
import a7 from './Margharita-20K-scaled.webp';
import a8 from './Spritz.20K-scaled.webp';
import a9 from './TL-Smash-beef-burger-4.-38k-jpg-min-scaled.jpg';
import a10 from './TL-pattern.svg';
import a11 from './The-Local-Drinks-Menu-0001-scaled.webp';
import a12 from './The-Local-Drinks-Menu-0002-scaled.webp';
import a13 from './The-Local-Drinks-Menu-0003-scaled.webp';
import a14 from './The-Local-Drinks-Menu-0004-scaled.webp';
import a15 from './The-Local-Drinks-Menu-0005-scaled.webp';
import a16 from './The-Local-Drinks-Menu-0006-scaled.webp';
import a17 from './The-Local-Drinks-Menu-0007-scaled.webp';
import a18 from './The-Local-Drinks-Menu-0008-scaled.webp';
import a19 from './The-Local-Drinks-Menu-0009-scaled.webp';
import a20 from './The-Local-Drinks-Menu-0010-scaled.webp';
import a21 from './The-Local-Drinks-Menu-0011-scaled.webp';
import a22 from './The-Local-Drinks-Menu-0012-scaled.webp';
import a23 from './The-Local-Drinks-Menu-0013-scaled.webp';
import a24 from './The-Local-Drinks-Menu-0014-scaled.webp';
import a25 from './The-Local-Drinks-Menu-0015-scaled.webp';
import a26 from './The-Local-Food-Menu-0001-scaled.webp';
import a27 from './The-Local-Food-Menu-0002-scaled.webp';
import a28 from './The-Local-Food-Menu-0003-scaled.webp';
import a29 from './The-Local-Food-Menu-0004-scaled.webp';
import a30 from './The-Local-Food-Menu-0005-scaled.webp';
import a31 from './The-Local-Food-Menu-0006-scaled.webp';
import a32 from './The-Local-Food-Menu-0007-scaled.webp';
import a33 from './The-Local-Food-Menu-0008-scaled.webp';
import a34 from './The-Local-Food-Menu-0009-scaled.webp';
import a35 from './The-Local-Food-Menu-0010-scaled.webp';
import a36 from './The-Local-Food-Menu-0011-scaled.webp';
import a37 from './The-Local-Food-Menu1.webp';
import a38 from './The-Local-Food-Menu10.webp';
import a39 from './The-Local-Food-Menu2.webp';
import a40 from './The-Local-Food-Menu4.webp';
import a41 from './The-Local-Food-Menu5.webp';
import a42 from './The-Local-Food-Menu6.webp';
import a43 from './The-Local-Food-Menu77.webp';
import a44 from './The-Local-Food-Menu8.webp';
import a45 from './The-Local-Food-Menu9.webp';
import a46 from './The-Local-Logos-01.svg';
import a47 from './The-Local-Logos-02.svg';
import a48 from './The-Local-Logos-03.svg';
import a49 from './The-Local-Logos-04.svg';
import a50 from './The-Signatures-20K1-scaled.webp';
import a51 from './menu-bg-01.svg';
import a52 from './motif-1.svg';

const BUNDLED = {
  "2150878299.jpg": a0,
  "Bugolobi-location-arrows-04.svg": a1,
  "Golden-Hour-0000.webp": a2,
  "Golden-hour-Table-talker-02.webp": a3,
  "Grain-background.webp": a4,
  "Kyanja-location-arrows-05.svg": a5,
  "Lavender-Lemonades-min-scaled.jpg": a6,
  "Margharita-20K-scaled.webp": a7,
  "Spritz.20K-scaled.webp": a8,
  "TL-Smash-beef-burger-4.-38k-jpg-min-scaled.jpg": a9,
  "TL-pattern.svg": a10,
  "The-Local-Drinks-Menu-0001-scaled.webp": a11,
  "The-Local-Drinks-Menu-0002-scaled.webp": a12,
  "The-Local-Drinks-Menu-0003-scaled.webp": a13,
  "The-Local-Drinks-Menu-0004-scaled.webp": a14,
  "The-Local-Drinks-Menu-0005-scaled.webp": a15,
  "The-Local-Drinks-Menu-0006-scaled.webp": a16,
  "The-Local-Drinks-Menu-0007-scaled.webp": a17,
  "The-Local-Drinks-Menu-0008-scaled.webp": a18,
  "The-Local-Drinks-Menu-0009-scaled.webp": a19,
  "The-Local-Drinks-Menu-0010-scaled.webp": a20,
  "The-Local-Drinks-Menu-0011-scaled.webp": a21,
  "The-Local-Drinks-Menu-0012-scaled.webp": a22,
  "The-Local-Drinks-Menu-0013-scaled.webp": a23,
  "The-Local-Drinks-Menu-0014-scaled.webp": a24,
  "The-Local-Drinks-Menu-0015-scaled.webp": a25,
  "The-Local-Food-Menu-0001-scaled.webp": a26,
  "The-Local-Food-Menu-0002-scaled.webp": a27,
  "The-Local-Food-Menu-0003-scaled.webp": a28,
  "The-Local-Food-Menu-0004-scaled.webp": a29,
  "The-Local-Food-Menu-0005-scaled.webp": a30,
  "The-Local-Food-Menu-0006-scaled.webp": a31,
  "The-Local-Food-Menu-0007-scaled.webp": a32,
  "The-Local-Food-Menu-0008-scaled.webp": a33,
  "The-Local-Food-Menu-0009-scaled.webp": a34,
  "The-Local-Food-Menu-0010-scaled.webp": a35,
  "The-Local-Food-Menu-0011-scaled.webp": a36,
  "The-Local-Food-Menu1.webp": a37,
  "The-Local-Food-Menu10.webp": a38,
  "The-Local-Food-Menu2.webp": a39,
  "The-Local-Food-Menu4.webp": a40,
  "The-Local-Food-Menu5.webp": a41,
  "The-Local-Food-Menu6.webp": a42,
  "The-Local-Food-Menu77.webp": a43,
  "The-Local-Food-Menu8.webp": a44,
  "The-Local-Food-Menu9.webp": a45,
  "The-Local-Logos-01.svg": a46,
  "The-Local-Logos-02.svg": a47,
  "The-Local-Logos-03.svg": a48,
  "The-Local-Logos-04.svg": a49,
  "The-Signatures-20K1-scaled.webp": a50,
  "menu-bg-01.svg": a51,
  "motif-1.svg": a52,
};

export default BUNDLED;
